export const InterviewStatuses = {
    PENDING: 'pending',
    AWAITING_CANDIDATE_RESPONSE: 'awaiting-candidate-response',
    AWAITING_CLIENT_AVAILABILITY: 'awaiting-client-availability',
    COMPLETED: 'interview-completed',
    SCHEDULED: 'interview-scheduled',
    REJECTED: 'interview-rejected',
    DEVELOPER_PROPOSED_ALTERNATE_SCHEDULE: 'developer-proposed-alternate-schedule',
    CLOSED: 'closed',
    DEVELOPER_NOSHOW: 'developer-noshow',
    CUSTOMER_NOSHOW: 'customer-noshow',
    DEVELOPER_NOT_AVAILABLE: 'developer-not-available',
    DEVELOPER_NOT_INTERESTED: 'developer-not-interested',
}

export const ActivitySeverityType = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};

const PRESHORTLIST_ACTIONS = {
    PRESHORTLISTED: 'PRESHORTLISTED',
    RECOMMENDED: 'RECOMMENDED',
    CONTACTED: 'CONTACTED',
    INTERESTED: 'INTERESTED',
    COMPLETED_VETSMITH: 'COMPLETED_VETSMITH',
    UNAVAILABLE: 'UNAVAILABLE',
    DISCARDED: 'DISCARDED',
    SHORTLISTED: 'SHORTLISTED',
    REMATCH: 'REMATCH',
    FAILED: 'FAILED',
};

const SLA_HM_SEARCH_API_ACTIONS = {
    SLA_HM_SEARCH_API_CALL: 'SLA_HM_SEARCH_API_CALL',
};

const HIRING_INSIGHT_LOG_ACTIONS = {
    HM_COUNT_SEARCH_API: 'HM_COUNT_SEARCH_API',
    RECO_COUNT_SEARCH_API: 'RECO_COUNT_SEARCH_API',
    RATE_PREDICTION_API: 'RATE_PREDICTION_API',
    SAMPLE_PROFILE_DEVS: 'SAMPLE_PROFILE_DEVS',
    AUTO_SL_SAMPLE_PROFILE_DEVS: 'AUTO_SL_SAMPLE_PROFILE_DEVS',
};

export const ActivityTypes = {
    INTERACTIVE_PACKET: {
        KEY: 'INTERACTIVE_PACKET',
        ACTIONS: {
            OPENED_PACKET: 'OPENED_PACKET',
            OPENED_EMAIL: 'OPENED_EMAIL',
            CONFIRMED_PACKET: 'CONFIRMED_PACKET',
            SCHEDULED_INTERVIEW: 'SCHEDULED_INTERVIEW',
            CREATE_OR_UPDATE_INTERVIEW: 'CREATE_OR_UPDATE_INTERVIEW',
            REJECTED_PACKET: 'REJECTED_PACKET',
            CREATED_PACKET: 'CREATED_PACKET',
            UPDATED_PACKET: 'UPDATED_PACKET',
            SENT_PACKET: 'SENT_PACKET',
            UPDATED_PACKET_STATUS: 'UPDATED_PACKET_STATUS',
            UPDATED_PACKET_DEVELOPER_STATUS: 'UPDATED_PACKET_DEVELOPER_STATUS',
            TURING_CALENDAR_CREATE_EVENTS: 'TURING_CALENDAR_CREATE_EVENTS',
            TURING_CALENDAR_CREATED_EVENTS: 'TURING_CALENDAR_CREATE_EVENTS',
            TURING_CALENDAR_SET_AVAILABILITY: 'TURING_CALENDAR_SET_AVAILABILITY',
            PACKET_SENT_WITH_MAGIC_LINK: 'PACKET_SENT_WITH_MAGIC_LINK',
            DELETED_DEVELOPER_FROM_PACKET: 'DELETED_DEVELOPER_FROM_PACKET',
            REJECTED_BY_AE: 'REJECTED_BY_AE',
        },
    },
    JOB_WORKFLOW: {
        KEY: 'JOB_WORKFLOW',
        ACTIONS: {
            SAVE_WORKFLOW_FOR_JOB: 'SAVE_WORKFLOW_FOR_JOB',
            REASSIGN_WORKFLOW_ITEM: 'REASSIGN_WORKFLOW_ITEM',
        },
    },
    JOB_LOGS: {
        KEY: 'JOB',
        ACTIONS: {
            UPDATED_STATUS: 'UPDATED_STATUS',
            LOCATION_PREFERENCES_UPDATED: 'LOCATION_PREFERENCES_UPDATED',
        },
    },
    JOB_MATCH_LOGS: {
        KEY: 'JOB_MATCH',
        ACTIONS: {
            UPDATED_STATUS: 'UPDATED_STATUS',
        },
    },
    FEEDBACK_SUBMIT_LOGS: {
        KEY: 'FEEDBACK_SUBMIT_LOGS',
        ACTIONS: {
            EMAIL_OPENED: 'EMAIL_OPENED',
            EMAIL_SENT: 'EMAIL_SENT',
            EMAIL_RESENT: 'EMAIL_RESENT',
            FORM_OPENED: 'FORM_OPENED',
            FORM_MOBILE_OPENED: 'FORM_MOBILE_OPENED',
            FORM_DESKTOP_OPENED: 'FORM_DESKTOP_OPENED',
            FORM_IMPRESSION_SUBMITTED: 'FORM_IMPRESSION_SUBMITTED',
            FORM_ADDITIONAL_QUESTIONS_SUBMITTED: 'FORM_ADDITIONAL_QUESTIONS_SUBMITTED',
            FORM_POSITIVE_FEEDBACK_HOVERED: 'FORM_POSITIVE_FEEDBACK_HOVERED',
            FORM_NEGATIVE_FEEDBACK_HOVERED: 'FORM_NEGATIVE_FEEDBACK_HOVERED',
            FORM_NOT_SURE_FEEDBACK_HOVERED: 'FORM_NOT_SURE_FEEDBACK_HOVERED',
            FORM_DEVELOPER_PROFILE_CLICKED: 'FORM_DEVELOPER_PROFILE_CLICKED',
            FORM_POSITIVE_FEEDBACK_CLICKED: 'FORM_POSITIVE_FEEDBACK_CLICKED',
            FORM_NEGATIVE_FEEDBACK_CLICKED: 'FORM_NEGATIVE_FEEDBACK_CLICKED',
            FORM_NOT_SURE_FEEDBACK_CLICKED: 'FORM_NOT_SURE_FEEDBACK_CLICKED',
            FORM_SUBMIT_FEEDBACK_DISCONTINUED: 'FORM_SUBMIT_FEEDBACK_DISCONTINUED',
            FORM_SUBMIT_FEEDBACK_CLICKED: 'FORM_SUBMIT_FEEDBACK_CLICKED',
            FORM_QUESTION_HOVERED: 'FORM_QUESTION_HOVERED',
            FORM_ANSWER_CLICKED: 'FORM_ANSWER_CLICKED',
            FORM_SUBMIT_ANSWERS_CLICKED: 'FORM_SUBMIT_ANSWERS_CLICKED',
            FORM_THANK_YOU_PAGE_OPENED: 'FORM_THANK_YOU_PAGE_OPENED',
            FORM_SUBMIT_POSITIVE_CLICKED: 'FORM_SUBMIT_POSITIVE_CLICKED',
            FORM_VIEW_MORE_DEVELOPERS_CLICKED: 'FORM_VIEW_MORE_DEVELOPERS_CLICKED',
            FORM_OPENED_FROM_EMAIL: 'FORM_OPENED_FROM_EMAIL',
            FORM_NEXT_ROUND_INTERVIEW_SCHEDULED: 'FORM_NEXT_ROUND_INTERVIEW_SCHEDULED',
        },
    },
    PREP_CALL: {
        KEY: 'PREP_CALL',
        ACTIONS: {
            [InterviewStatuses.PENDING]: 'CREATED_PREP_CALL',
            [InterviewStatuses.AWAITING_CANDIDATE_RESPONSE]: 'AWAITING_CANDIDATE_RESPONSE',
            [InterviewStatuses.SCHEDULED]: 'PREP_CALL_SCHEDULED',
            [InterviewStatuses.COMPLETED]: 'PREP_CALL_COMPLETED',
            [InterviewStatuses.CLOSED]: 'CLOSED',
        },
    },
    USER_LOGS: {
        KEY: 'USER',
        ACTIONS: {
            UPDATE_USER: 'UPDATE_USER',
            CREATE_USER: 'CREATE_USER',
            RESTORE_USER: 'RESTORE_USER',
            DELETE_USER: 'DELETE_USER',
        },
    },
    DEVELOPER_RECOMMENDATIONS_LOGS: {
        KEY: 'DEVELOPER_RECOMMENDATIONS',
        ACTIONS: {
            FETCH_FROM_RECOMMENDATIONS_ENGINE: 'FETCH_FROM_RECOMMENDATIONS_ENGINE',
            FETCH_FROM_MATCHING_DB: 'FETCH_FROM_MATCHING_DB',
        },
    },
    RECOMMENDED_JOB_LOGS: {
        KEY: 'RECOMMENDED_JOBS',
        ACTIONS: {
            FETCH_HMS_DEVELOPERS_FROM_SEARCH: 'FETCH_HMS_DEVELOPERS_FROM_SEARCH',
            CREATED_HMS_DEVELOPERS_FROM_SEARCH: 'CREATED_HMS_DEVELOPERS_FROM_SEARCH',
            SENT_DEVELOPER_RECOMMENDED_JOBS_TO_SUPPLY: 'SENT_DEVELOPER_RECOMMENDED_JOBS_TO_SUPPLY',
        },
    },
    PRESHORTLIST: {
        KEY: 'PRESHORTLIST',
        ACTIONS: PRESHORTLIST_ACTIONS,
    },
    PRESHORTLIST_COUNT: {
        KEY: 'PRESHORTLIST_COUNT',
        ACTIONS: PRESHORTLIST_ACTIONS,
    },
    SLA_HM_SEARCH_API_LOGS: {
        KEY: 'SLA_HM_SEARCH_API_LOGS',
        ACTIONS: SLA_HM_SEARCH_API_ACTIONS,
    },
    HIRING_INSIGHT_LOGS: {
        KEY: 'HIRING_INSIGHT_LOGS',
        ACTIONS: HIRING_INSIGHT_LOG_ACTIONS,
    },
    DEEP_DEVELOPER_PROFILE: {
        KEY: 'DEEP_DEVELOPER_PROFILE',
        ACTIONS: {
            DDP_LOADED: 'DDP_LOADED',
            GENERATE_TEMP_DDP_LINK: 'GENERATE_TEMP_DDP_LINK',
        },
    },
    AUTO_SHORTLIST: {
        KEY: 'AUTO_SHORTLIST',
        ACTIONS: {
            RANKING_SERVICE_DEBUG: 'RANKING_SERVICE_DEBUG',
        },
    },
    AUTO_PRE_SHORTLIST: {
        KEY: 'AUTO_PRE_SHORTLIST',
        ACTIONS: {
            RANKING_SERVICE_DEBUG: 'RANKING_SERVICE_DEBUG',
        },
    },
    DEVELOPER_SKILLS: {
        KEY: 'DEVELOPER_SKILLS',
        ACTIONS: {
            IS_READY_TO_MATCH_FLAG_TOGGLED: 'IS_READY_TO_MATCH_FLAG_TOGGLED',
        },
    },
    PERFORMANCE: {
        KEY: 'PERFORMANCE',
        ACTIONS: {
            JOB_MATCH_LIST_BY_TALENT_OPS: 'JOB_MATCH_LIST_BY_TALENT_OPS',
            DEVELOPER_JOB_APPLICATION_LIST: 'DEVELOPER_JOB_APPLICATION_LIST',
        },
    },
    ICF: {
        KEY: 'ICF',
        ACTIONS: {
            ICF_VIEWED: 'ICF_VIEWED',
            ICF_SESSION_SNAP_SHOT: 'ICF_SESSION_SNAP_SHOT',
        },
    },
};

export const APILogs = {
    HIRING_INSIGHT_APIS: {
        KEY: 'HIRING_INSIGHT_APIS',
        ACTIONS: {
            LISTING: 'LISTING',
            CREATE: 'CREATE',
            UPDATE: 'UPDATE',
            GENERATE_REPORT: 'GENERATE_REPORT',
            RECOMMENDATION: 'RECOMMENDATION',
            RATE_PREDICTION: 'RATE_PREDICTION',
            SAMPLE_PROFILES_AUTOSL: 'SAMPLE_PROFILES_AUTOSL',
            LINK_JOB: 'LINK_JOB',
        },
    },
    JOB_CREATION_APIS: {
        KEY: 'JOB_CREATION_APIS',
        ACTIONS: {
            CREATE: 'CREATE',
            UPDATE: 'UPDATE',
            CREATE_DRAFT: 'CREATE_DRAFT',
            UPDATE_DRAFT: 'UPDATE_DRAFT',
        },
    },
    JOB_DETAIL_APIS: {
        KEY: 'JOB_DETAIL_APIS',
        ACTIONS: {
            FETCH: 'FETCH',
        },
    },
    JOB_DEVS_APIS: {
        KEY: 'JOB_DEVS_APIS',
        ACTIONS: {
            FETCH_SLA: 'FETCH_SLA',
        },
    },
    SHORTLIST_APIS: {
        KEY: 'SHORTLIST_APIS',
        ACTIONS: {
            SHORTLISTED_DEVELOPERS: 'SHORTLISTED_DEVELOPERS',
            REJECTED_DEVELOPERS: 'REJECTED_DEVELOPERS',
        },
    },
    JOB_PACKET_APIS: {
        KEY: 'JOB_PACKET_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
        },
    },
    JOB_ENGAGEMENT_APIS: {
        KEY: 'JOB_ENGAGEMENT_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
            FETCH_ALL_FOR_DEV: 'FETCH_ALL_FOR_DEV',
            ADD_FEEDBACK: 'ADD_FEEDBACK',
            UPDATE_FEEDBACK: 'UPDATE_FEEDBACK',
            FETCH_FEEDBACK: 'FETCH_FEEDBACK',
        },
    },
    COMPANIES_APIS: {
        KEY: 'COMPANIES_APIS',
        ACTIONS: {
            CREATE: 'CREATE',
            UPDATE: 'UPDATE',
            LISTING: 'LISTING',
            VIEW_DETAILS: 'VIEW_DETAILS',
            CONTACTS: 'CONTACTS',
            ENGAGEMENTS: 'ENGAGEMENTS',
            GET_JOBS_COUNT: 'GET_JOBS_COUNT',
            GET_JOBS: 'GET_JOBS',
            FETCH_SERVICES: 'FETCH_SERVICES',
        },
    },
    SERVICES_APIS: {
        KEY: 'SERVICES_APIS',
        ACTIONS: {
            LISTING: 'LISTING',
            CREATE: 'CREATE',
            UPDATE: 'UPDATE',
            VIEW_DETAILS: 'VIEW_DETAILS',
            GET_JOBS_COUNT: 'GET_JOBS_COUNT',
            GET_JOBS: 'GET_JOBS',
            ATTACH_EXISTING_JOB: 'ATTACH_EXISTING_JOB',
        },
    },
    JOB_SEARCH_APIS: {
        KEY: 'JOB_SEARCH_APIS',
        ACTIONS: {
            SEARCH: 'SEARCH',
            SEARCH_WITHIN_DATE_RANGE: 'SEARCH_WITHIN_DATE_RANGE',
        },
    },
    OPP_LEADS_APIS: {
        KEY: 'OPP_LEADS_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
        },
    },
    INTERVIEW_TRACKING_APIS: {
        KEY: 'INTERVIEW_TRACKING_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
            FETCH_ONE: 'FETCH_ONE',
            FETCH_ALL_BY_JOB: 'FETCH_ALL_BY_JOB',
            FETCH_JOB_MATCH: 'FETCH_JOB_MATCH',
            CREATE_OR_UPDATE: 'CREATE_OR_UPDATE',
            UPDATE_BULK: 'UPDATE_BULK',
            UPDATE: 'UPDATE',
            UPDATE_DEVELOPER_STATUS: 'UPDATE_DEVELOPER_STATUS',
            UPDATE_INTERVIEW_STATUS: 'UPDATE_INTERVIEW_STATUS',
        },
    },
    INTERVIEW_FEEDBACK_APIS: {
        KEY: 'INTERVIEW_FEEDBACK_APIS',
        ACTIONS: {
            REQUEST_FEEDBACK_WITH_INTERVIEW_STAGE: 'REQUEST_FEEDBACK_WITH_INTERVIEW_STAGE',
            REQUEST_FEEDBACK: 'REQUEST_FEEDBACK',
            FETCH_INTERNAL_FEEDBACK: 'FETCH_INTERNAL_FEEDBACK',
            UPDATE_INTERNAL_FEEDBACK: 'UPDATE_INTERNAL_FEEDBACK',
        },
    },
    INTERVIEWS_APIS: {
        KEY: 'INTERVIEWS_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
        },
    },
    PACKET_APIS: {
        KEY: 'PACKET_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
        },
    },
    ENGAGEMENT_APIS: {
        KEY: 'ENGAGEMENT_APIS',
        ACTIONS: {
            FETCH_ALL: 'FETCH_ALL',
        },
    },
};
